import { ComponentPropsWithRef } from "react";

export const MinimalPlayIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 1.00098C0.000291548 0.231412 0.83345 -0.249091 1.5 0.135742L12 6.19727C12.6667 6.58217 12.6667 7.54479 12 7.92969L1.5 13.9922C0.833433 14.3769 0.000173175 13.8956 0 13.126V1.00098Z"
      fill="currentColor"
    />
  </svg>
);
